/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { __awaiter, __extends, __generator } from "tslib";
import * as runtime from '../runtime';
import { NetworkRequestToJSON, NetworkResponseFromJSON, PagedResponseOfNetworkListEntryFromJSON, } from '../models';
/**
 *
 */
var NetworkRestControllerApi = /** @class */ (function (_super) {
    __extends(NetworkRestControllerApi, _super);
    function NetworkRestControllerApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create a new network  \'Permission#CREATE_NETWORK\' is required to access to this endpoint
     * Create a new network  \'Permission#CREATE_NETWORK\' is required to access to this endpoint
     */
    NetworkRestControllerApi.prototype.createNetworkRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.networkRequest === null || requestParameters.networkRequest === undefined) {
                            throw new runtime.RequiredError('networkRequest', 'Required parameter requestParameters.networkRequest was null or undefined when calling createNetwork.');
                        }
                        queryParameters = {};
                        if (requestParameters.contextOrganisation !== undefined) {
                            queryParameters['contextOrganisation'] = requestParameters.contextOrganisation;
                        }
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (this.configuration && this.configuration.accessToken) {
                            // oauth required
                            if (typeof this.configuration.accessToken === 'function') {
                                headerParameters["Authorization"] = this.configuration.accessToken("keycloak", []);
                            }
                            else {
                                headerParameters["Authorization"] = this.configuration.accessToken;
                            }
                        }
                        return [4 /*yield*/, this.request({
                                path: "/networks",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: NetworkRequestToJSON(requestParameters.networkRequest)
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return NetworkResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Create a new network  \'Permission#CREATE_NETWORK\' is required to access to this endpoint
     * Create a new network  \'Permission#CREATE_NETWORK\' is required to access to this endpoint
     */
    NetworkRestControllerApi.prototype.createNetwork = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createNetworkRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete network and all resources belonging to this network transitively  \'Permission#DELETE_NETWORK\' is required to access to this endpoint
     * Delete network and all resources belonging to this network transitively  \'Permission#DELETE_NETWORK\' is required to access to this endpoint
     */
    NetworkRestControllerApi.prototype.deleteNetworkRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.networkId === null || requestParameters.networkId === undefined) {
                            throw new runtime.RequiredError('networkId', 'Required parameter requestParameters.networkId was null or undefined when calling deleteNetwork.');
                        }
                        queryParameters = {};
                        if (requestParameters.contextOrganisation !== undefined) {
                            queryParameters['contextOrganisation'] = requestParameters.contextOrganisation;
                        }
                        headerParameters = {};
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (this.configuration && this.configuration.accessToken) {
                            // oauth required
                            if (typeof this.configuration.accessToken === 'function') {
                                headerParameters["Authorization"] = this.configuration.accessToken("keycloak", []);
                            }
                            else {
                                headerParameters["Authorization"] = this.configuration.accessToken;
                            }
                        }
                        return [4 /*yield*/, this.request({
                                path: "/networks/{networkId}".replace("{".concat("networkId", "}"), encodeURIComponent(String(requestParameters.networkId))),
                                method: 'DELETE',
                                headers: headerParameters,
                                query: queryParameters
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Delete network and all resources belonging to this network transitively  \'Permission#DELETE_NETWORK\' is required to access to this endpoint
     * Delete network and all resources belonging to this network transitively  \'Permission#DELETE_NETWORK\' is required to access to this endpoint
     */
    NetworkRestControllerApi.prototype.deleteNetwork = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deleteNetworkRaw(requestParameters)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Get network details  \'Permission#READ_NETWORK\' is required to access to this endpoint
     * Get network details  \'Permission#READ_NETWORK\' is required to access to this endpoint
     */
    NetworkRestControllerApi.prototype.getNetworkRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.networkId === null || requestParameters.networkId === undefined) {
                            throw new runtime.RequiredError('networkId', 'Required parameter requestParameters.networkId was null or undefined when calling getNetwork.');
                        }
                        queryParameters = {};
                        if (requestParameters.contextOrganisation !== undefined) {
                            queryParameters['contextOrganisation'] = requestParameters.contextOrganisation;
                        }
                        headerParameters = {};
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (this.configuration && this.configuration.accessToken) {
                            // oauth required
                            if (typeof this.configuration.accessToken === 'function') {
                                headerParameters["Authorization"] = this.configuration.accessToken("keycloak", []);
                            }
                            else {
                                headerParameters["Authorization"] = this.configuration.accessToken;
                            }
                        }
                        return [4 /*yield*/, this.request({
                                path: "/networks/{networkId}".replace("{".concat("networkId", "}"), encodeURIComponent(String(requestParameters.networkId))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return NetworkResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get network details  \'Permission#READ_NETWORK\' is required to access to this endpoint
     * Get network details  \'Permission#READ_NETWORK\' is required to access to this endpoint
     */
    NetworkRestControllerApi.prototype.getNetwork = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getNetworkRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * List networks using pagination  \'Permission#READ_NETWORK\' is required to access to this endpoint
     * List networks using pagination  \'Permission#READ_NETWORK\' is required to access to this endpoint
     */
    NetworkRestControllerApi.prototype.listNetworksRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.contextOrganisation !== undefined) {
                            queryParameters['contextOrganisation'] = requestParameters.contextOrganisation;
                        }
                        if (requestParameters.page !== undefined) {
                            queryParameters['page'] = requestParameters.page;
                        }
                        if (requestParameters.size !== undefined) {
                            queryParameters['size'] = requestParameters.size;
                        }
                        headerParameters = {};
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (this.configuration && this.configuration.accessToken) {
                            // oauth required
                            if (typeof this.configuration.accessToken === 'function') {
                                headerParameters["Authorization"] = this.configuration.accessToken("keycloak", []);
                            }
                            else {
                                headerParameters["Authorization"] = this.configuration.accessToken;
                            }
                        }
                        return [4 /*yield*/, this.request({
                                path: "/networks",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return PagedResponseOfNetworkListEntryFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * List networks using pagination  \'Permission#READ_NETWORK\' is required to access to this endpoint
     * List networks using pagination  \'Permission#READ_NETWORK\' is required to access to this endpoint
     */
    NetworkRestControllerApi.prototype.listNetworks = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.listNetworksRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Update network  \'Permission#UPDATE_NETWORK\' is required to access to this endpoint
     * Update network  \'Permission#UPDATE_NETWORK\' is required to access to this endpoint
     */
    NetworkRestControllerApi.prototype.updateNetworkRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.networkId === null || requestParameters.networkId === undefined) {
                            throw new runtime.RequiredError('networkId', 'Required parameter requestParameters.networkId was null or undefined when calling updateNetwork.');
                        }
                        if (requestParameters.networkRequest === null || requestParameters.networkRequest === undefined) {
                            throw new runtime.RequiredError('networkRequest', 'Required parameter requestParameters.networkRequest was null or undefined when calling updateNetwork.');
                        }
                        queryParameters = {};
                        if (requestParameters.contextOrganisation !== undefined) {
                            queryParameters['contextOrganisation'] = requestParameters.contextOrganisation;
                        }
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
                            headerParameters['Authorization'] = String(requestParameters.authorization);
                        }
                        if (this.configuration && this.configuration.accessToken) {
                            // oauth required
                            if (typeof this.configuration.accessToken === 'function') {
                                headerParameters["Authorization"] = this.configuration.accessToken("keycloak", []);
                            }
                            else {
                                headerParameters["Authorization"] = this.configuration.accessToken;
                            }
                        }
                        return [4 /*yield*/, this.request({
                                path: "/networks/{networkId}".replace("{".concat("networkId", "}"), encodeURIComponent(String(requestParameters.networkId))),
                                method: 'PUT',
                                headers: headerParameters,
                                query: queryParameters,
                                body: NetworkRequestToJSON(requestParameters.networkRequest)
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return NetworkResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Update network  \'Permission#UPDATE_NETWORK\' is required to access to this endpoint
     * Update network  \'Permission#UPDATE_NETWORK\' is required to access to this endpoint
     */
    NetworkRestControllerApi.prototype.updateNetwork = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateNetworkRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return NetworkRestControllerApi;
}(runtime.BaseAPI));
export { NetworkRestControllerApi };
